import React, {useContext, useEffect, useState} from "react";

const GlobalContext = React.createContext(undefined)

export function useGlobal() {
    return useContext(GlobalContext)
}

export default function SpeechProvider({children}) {
    const [result, setResult] = useState("Say something...")
    const [isSideBarShow, setSideBarShow] = useState(false)
    const [activeSite, setActiveSite] = useState("")
    const [isJokeActive, setJokeActive] = useState(0);


    const [width, setWidth] = useState(window.innerWidth);

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    const isMobile = (width <= 768);

    const value = {
        result, setResult, isSideBarShow, setSideBarShow, activeSite, setActiveSite, isMobile, isJokeActive, setJokeActive
    }

    return (
        <GlobalContext.Provider value={value}>
            {children}
        </GlobalContext.Provider>
    );
}
